import React from 'react';

import classNames from 'classnames';

export default function Circle({ children, className }) {
  return (
    <span className={classNames('app-circle', className)}>{children}</span>
  );
}
